export enum PROCEDURE_TARGET_EDITION {
  DESCRIPTION = 'description',
  LABEL = 'label',
}
